var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "site-create-form" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("补充基础信息")]),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            "label-position": "top",
            "label-width": "80px",
            model: _vm.form,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "item-content",
              attrs: { label: "店铺名称", prop: "name" },
            },
            [
              _c("el-input", {
                staticClass: "item-input",
                attrs: { placeholder: "例如:Patricia Gutkowski" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "item-content",
              attrs: { label: "行业", prop: "category" },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "item-input",
                  attrs: { multiple: "", placeholder: "请选择行业" },
                  model: {
                    value: _vm.form.category,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "category", $$v)
                    },
                    expression: "form.category",
                  },
                },
                _vm._l(_vm.cateOptions, function (item) {
                  return _c("el-option", {
                    key: item.dictItemValue,
                    attrs: {
                      label: item.dictItemKey,
                      value: item.dictItemValue,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "desc" }, [
            _vm._v(
              "站点复制内容包括：商品、商品系列、网站地图、文章、站点装修、营销活动、配送设置、弹窗通知。"
            ),
          ]),
          _c(
            "el-form-item",
            { staticStyle: { "text-align": "right", "margin-bottom": "0" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleForm },
                },
                [_vm._v("创建站点")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }